import { topicsData } from '@/mocks/homeData';

const tagColorMap: Record<string, string> = {
  primary: 'bg-primary-100 text-primary-700 hover:bg-primary-200',
  accent: 'bg-accent-100 text-accent-700 hover:bg-accent-200',
  secondary: 'bg-secondary-100 text-secondary-700 hover:bg-secondary-200',
};

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <p className="text-xs font-semibold text-secondary-500 uppercase tracking-wider mb-2">HOT TOPICS</p>
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-900">热门话题</h2>
          <p className="text-sm text-foreground-600 mt-3 max-w-lg mx-auto">
            吃瓜网站当前最受关注的热门话题标签，点击探索更多内容
          </p>
        </div>

        <div className="max-w-3xl mx-auto flex flex-wrap justify-center gap-3">
          {topicsData.map((topic, i) => (
            <a
              key={i}
              href="#topics"
              className={`group flex items-center gap-2 px-5 py-2.5 rounded-full text-sm font-medium transition-all cursor-pointer whitespace-nowrap ${tagColorMap[topic.color]}`}
            >
              <span>{topic.name}</span>
              <span className="text-[10px] opacity-70 font-normal">{topic.heat}</span>
            </a>
          ))}
        </div>

        <div className="text-center mt-8">
          <p className="text-xs text-foreground-500">
            以上话题数据基于吃瓜网站实时热度统计，每30分钟更新一次
          </p>
        </div>
      </div>
    </section>
  );
}